/* src/app/userentrydates/presenters/userentrydates-presenters.component.scss */
.overlay {
  position: fixed;
  top: 0px;
  left: 0px;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  z-index: 99999;
}
.overlay-content {
  opacity: 1;
  background: lightgray;
  border: 1px solid lightgray;
  box-shadow: 5px 8px 5px black;
  z-index: 999999;
}
.page-overlay {
  position: fixed;
  top: 0px;
  left: 0px;
  opacity: 0.5;
  width: 100vw;
  height: 100vh;
  z-index: 99;
  background-color: #000;
}
.page-overlay-content {
  opacity: 1;
  position: fixed;
  top: 40%;
  left: 40%;
  color: white;
  font-size: 4rem;
  background-color: transparent;
  box-shadow: 5px 8px 5px black;
  z-index: 999999;
}
/*# sourceMappingURL=userentrydates-presenters.component.css.map */
